import { useCallback, useState } from 'react';

export default function useRerender() {
  const [, updateState] = useState();
  return useCallback(() => updateState({}), []);
}
